// src/components/billing/CancelReasonFields.jsx — why the customer cancels (v203), inside the «Disdici» confirm.
//
// ⭐ BOTH fields are OPTIONAL: no reason never blocks a cancellation, and the backend stores whatever is sent
// (subscription_departures). The codes are the backend's vocabulary (billingApi.CANCEL_REASON_CODES); the comment
// is capped at the backend's limit client-side, because a longer one is a 422 that cancels NOTHING.
// `value` = { reasonCode: string|null, comment: string }; `onChange` receives a NEW object (never mutated).
import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { CANCEL_REASON_CODES, CANCEL_COMMENT_MAX } from '../../billing/billingApi.js';
import { COLORS, FONT_SANS, RADII } from '../../constants/theme.js';

const FIELDSET = { border: 'none', padding: 0, margin: '6px 0 0', fontFamily: FONT_SANS };
const LEGEND = { fontSize: '13px', fontWeight: 600, color: COLORS.ink, padding: 0, marginBottom: '8px' };
const OPTION = { display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', color: COLORS.ink, margin: '0 0 6px', cursor: 'pointer' };
const LABEL = { display: 'block', fontSize: '13px', fontWeight: 600, color: COLORS.ink, margin: '12px 0 6px' };
const TEXTAREA = {
  width: '100%', boxSizing: 'border-box', padding: '8px 10px', borderRadius: RADII.controlInner,
  border: `1px solid ${COLORS.borderStrong}`, fontFamily: FONT_SANS, fontSize: '13px', color: COLORS.ink, resize: 'vertical',
};
const COUNTER = { fontSize: '11px', color: COLORS.textSecondary, textAlign: 'right', marginTop: '4px' };

export default function CancelReasonFields({ value, onChange, disabled = false }) {
  const { t } = useTranslation('billing');
  const id = useId();
  const commentId = `${id}-comment`;
  return (
    <fieldset style={FIELDSET} disabled={disabled}>
      <legend style={LEGEND}>{t('cancelReason.legend')}</legend>
      {CANCEL_REASON_CODES.map((code) => (
        <label key={code} style={OPTION}>
          <input type="radio" name={`${id}-reason`} value={code} checked={value.reasonCode === code}
                 onChange={() => onChange({ ...value, reasonCode: code })} />
          {t(`cancelReason.codes.${code}`)}
        </label>
      ))}
      <label htmlFor={commentId} style={LABEL}>{t('cancelReason.commentLabel')}</label>
      <textarea id={commentId} rows={3} maxLength={CANCEL_COMMENT_MAX} value={value.comment}
                onChange={(e) => onChange({ ...value, comment: e.target.value })} style={TEXTAREA} />
      <div style={COUNTER}>{t('cancelReason.counter', { n: value.comment.length, max: CANCEL_COMMENT_MAX })}</div>
    </fieldset>
  );
}
